import { EmployeeDismissalsService } from "./../../../services/documents/EmployeeDismissalsService";
import React from "react";
import { EmployeeDismissalsDetail } from "../../../components/Pages/Documents/EmployeeDismissals/EmployeeDismissalsDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateEmployeeDismissalsDto } from "../../../dtos/documents/EmployeeDismissals/CreateEmployeeDIsmissalsDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupEmployeeDismissals } from "../../../components/Shared/NewForms/NFLookupEmployeeDismissals";
import EmployeeDismissalsList from "../../../components/Pages/Documents/EmployeeDismissals/EmployeeDismissalsList";

export const EmployeeDismissals: IAppEntity = {
  entityType: "document",
  title: "Employee Dismissals",
  pluralTitle: "Employee Dismissals",
  apiUrl: "EmployeeDismissals",
  apiEnum: ReferenceTypes.DocumentEmployeeDismissal,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(EmployeeDismissalsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(EmployeeDismissalsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupEmployeeDismissals, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new EmployeeDismissalsService("EmployeeDismissals"),
  getEmptyModel: () => {
    const model: CreateEmployeeDismissalsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      departureDate: new Date(),
    };
    return model;
  },
};
